<template>
    <div>
    <v-card
        class="mx-auto mt-4"
        max-width="95%"
        elevation="2"
    >
    <v-toolbar
        color="#37474F"
        dark
    >
    
    <v-toolbar-title>코인주문 리스트 </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <!-- <v-text-field
        v-model="search_keyword"
        label="유저 아이디"        
        hide-details="auto"
        color:red
    ></v-text-field> -->
    <!-- <v-btn 
        icon
        @click="OnClick_SearchUser()"
    >
        <v-icon>mdi-magnify</v-icon>
    </v-btn> -->
    <v-btn
                color="blue"
                class='white--text ml-2'
                @click="checkBoxEnable_all()">선택하기</v-btn>


    <v-btn
        v-if="Object.values(enable_check_list).some(Boolean)"
        color="orange"
        class="white--text ml-2"
        @click="update_checked_Done()"
    >완료처리</v-btn>
    <!-- <v-btn v-if="Object.keys(enable_check_list).length > 0"
     width="120px"
                color="orange"
                class='white--text'
                @click="update_checked_Done()">완료처리</v-btn>                 -->
    </v-toolbar>

    <v-list two-line>
    <v-list-item-group        
        active-class="pink--text"
        multiple
    >
    <v-data-table         
        :footer-props="{'items-per-page-options':[20, 50, -1]}"
        :headers="headers" 
        :items="order_list"
        :loading="loadingData"
        >        
        
        <template v-slot:item="row">            
            <tr :style="{ backgroundColor: row.item.PROCESS_STATE === 'CANCEL' ? '#f0f0f0' : (isAfterThisMonday(row.item.CREATE_DT) ? '#FFF3E0' : '') }">
            <td><span class="font-weight-black">{{row.item.PID}}</span></td>
            <td>{{row.item.CREATE_DT}}</td>
            <td><span class="font-weight-black">{{row.item.USER_ID}}</span></td>
            <td><span class="font-weight-black">{{row.item.COIN_INFO}}</span></td>
            <td><span class="font-weight-black">{{row.item.SNAP_COIN_PRICE* 50000}}</span></td>
            <td><span class="font-weight-black">{{row.item.COIN}}</span></td>
            <td><span class="font-weight-black">{{row.item.UPBIT_ACCOUNT}}</span></td>
            <td><span class="font-weight-black">{{row.item.DESTINATION_TAG}}</span></td>
            <td>
                <v-checkbox
                    v-model="row.item.selected"
                    :disabled="!isEnableCheckBox(row.item.PID)"
                    :input-value="row.item.selected"
                    @change="row.item.selected = $event"
                    hide-details
                    dense
                ></v-checkbox>
            </td>
            <td><span class="font-weight-black" :style="{ color: row.item.PROCESS_STATE == 'WAIT' ? 'blue' : 'grey' }">{{row.item.PROCESS_STATE}}</span></td>

            <!-- <td>  <span class="font-weight-black" :style="{ color: row.item.ENABLE == 'Y' ? 'blue' : 'red' }">{{row.item.ENABLE}}</span></td>
            <td>  <span class="font-weight-black" :style="{ color: row.item.DESTINATION_TAG == 'Y' ? 'blue' : 'red' }">{{row.item.DESTINATION_TAG}}</span></td> -->
            <!-- <td v-if="dialog_selected_item.PROCESS_STATE == 'WAIT'"> -->
            <td>
                <v-btn
                color="indigo"
                class='white--text'
                @click="OnClick_ShowPopup_EditCoin(row.item)">상세</v-btn>
            </td>
            <!-- <td v-else>
                <span :style="{ fontWeight: '900'}">{{row.item.DISPATCH_DT}}</span>
            </td> -->
            </tr>
        </template>
    </v-data-table>
        </v-list-item-group>
    </v-list>
    </v-card>
    <v-dialog
      v-model="dialog_popup"
      max-width="680"
    >
    <v-card>
        <v-card-title class="text-h5 mb-3">
          {{'유저 주문명세[ ' +dialog_selected_item.USER_ID+" / "+dialog_selected_item.USER_NICK + " ]"}}
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12"  class="dialog_title_text" style="color: blue;"> 주문날짜 : {{dialog_selected_item.CREATE_DT}}</v-col>
            </v-row>
    <v-row>
        <v-col cols="5"  class="dialog_title_text">요청코인정보</v-col>
        <v-col class="dialog_info_text">
            {{ dialog_selected_item.COIN_INFO }}
        </v-col>
    </v-row>
    <v-divider style="height: 5px;"></v-divider>
    <v-row>
        <v-col cols="5"  class="dialog_title_text">업비트 계좌</v-col>
        <v-col class="dialog_info_text">
            {{ dialog_selected_item.UPBIT_ACCOUNT }}
        </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
        <v-col cols="5"  class="dialog_title_text">데스티네이션 태그</v-col>
        <v-col class="dialog_info_text">
            {{ dialog_selected_item.DESTINATION_TAG }}
        </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
        <v-col cols="5"  class="dialog_title_text">수취자 이름</v-col>
        <v-col class="dialog_info_text">
            {{ dialog_selected_item.RECIPIENT_NM }}
        </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
        <v-col cols="5"  class="dialog_title_text">주민등록 번호</v-col>
        <v-col class="dialog_info_text">
            {{ dialog_selected_item.KO_NATIONAL_ID }}
        </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
        <v-col cols="5"  class="dialog_title_text">주문당시 코인시세반영</v-col>
        <v-col class="dialog_info_text">
            {{ dialog_selected_item.COIN }}
        </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
        <v-col cols="5"  class="dialog_title_text">스냅코인 가격</v-col>
        <v-col class="dialog_info_text">
            {{ dialog_selected_item.SNAP_COIN_PRICE }}
        </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row class="align-center">
    <v-col cols="5" class="d-flex align-center">
        <div class="dialog_title_text" style="margin-top: 10px; margin-bottom: 10px;">처리상태</div>
    </v-col>

    <v-col v-if="dialog_selected_item.PROCESS_STATE == 'WAIT' || dialog_selected_item.PROCESS_STATE == ''" class="d-flex align-center">
        <v-select
        v-model="dropdown_selected"
        :items="dropdown_items"
        label="선택하세요"
        outlined
        dense
        hide-details
        style="width: 100%"
        ></v-select>
    </v-col>
    <v-col v-else class="d-flex align-center">
        <div class="dialog_info_text" style="margin-top: 10px; margin-bottom: 10px;">{{ dialog_selected_item.PROCESS_STATE }}</div>
    </v-col>
    </v-row>

    <v-divider></v-divider>
    <v-row>
        <v-col cols="5"  class="dialog_title_text">처리일시</v-col>
        <v-col class="dialog_info_text">
            {{ dialog_selected_item.DISPATCH_DT == null?'':dialog_selected_item.DISPATCH_DT }}
        </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row v-if="dropdown_selected == 'CANCEL'">
        <v-col  cols="5"  class="dialog_title_text">코멘트</v-col>    
    </v-row>
    <v-divider></v-divider>
    <v-row v-if="dropdown_selected == 'CANCEL' && (dialog_selected_item.PROCESS_STATE == 'WAIT' || dialog_selected_item.PROCESS_STATE == '')">
          <v-text-field 
                label="취소 환불사유 (완료시 작성 필요없음)"
                v-model="dialog_cancel_commment" 
                outlined
                dense
            ></v-text-field>
    </v-row>
    <v-row  v-if="dialog_selected_item.PROCESS_STATE == 'CANCEL'">
        <v-col  cols="5"  class="dialog_title_text">취소사유</v-col>    
        <v-col class="dialog_title_text">
         {{ dialog_selected_item.COMMENT }}
        </v-col>
    </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="OnClick_ClosePopup"
          >
            취소
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="OnClick_EditProductCoin"
          >
            확인
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>    
    
</template>

<script>
import { mapActions } from 'vuex';
import config from '../../config/config';
const { s3_upload , FileUpload_Async ,  FileUpload_JSON} = require("../../util/fileutil");
export default {
    name: 'UserList',

    data: () => ({
        loadingData:false,

        items :[{title:'USER_ID',
        subtitle:'닉네임',
        action:'우편' }],
        headers: [            
            { text: '주문번호', value: 'pid' },
            { text: '구매요청 시각', value: 'datetime' },
            { text: '유저아이디', value: 'user_id' },
            { text: '코인이름', value: 'coin_nm' },
            { text: '현금가치', value: 'state' },
            { text: '코인', value: 'state' },
            { text: '업비트계좌', value: 'state' },
            { text: '데스티네이션', value: 'state' },
            { text: '선택', value: 'select' },
            { text: '상태', value: 'state' },
            { text: '관리', value: 'manage' },
        ],
        order_list:[],
        total_count:0,
        search_keyword:'',
        enable_check_list :{},

        dialog_selected_item: {},
        dialog_popup:false,
        dialog_cancel_commment:'',


        dropdown_items: ['DONE', 'CANCEL'],
        dropdown_selected: null,
        dropdown_open: false,
    }),

    created()
    {
        console.log("TEST");
        this.Load_OrderList();
    },

    methods:{
        ...mapActions([
            "CPU_GET_COIN_ORDER_LIST",
            "CPU_SEARCH_COIN_ORDER_LIST",
            "CPU_EDIT_COIN_ORDER_STATE",
        ]),
        Load_OrderList()
        {
            this.CPU_GET_COIN_ORDER_LIST({count:200}).then((body_data)=>{
                this.order_list = body_data.order_list;
                this.enable_check_list = {};
                this.order_list.forEach(element => {
                    
                    if(!this.isAfterThisMonday(element.CREATE_DT) && element.PROCESS_STATE == 'WAIT'){ 
                        this.$set(this.enable_check_list, element.PID, true);
                    }
                    //this.$set(element, 'selected', false); // Add selected property to each item
                });

                console.log(JSON.stringify(this.order_list));
            });

        },
        OnClick_SearchUser()
        {
            this.CPU_SEARCH_COIN_ORDER_LIST({user_id:this.search_keyword}).then((body_data)=>{
                this.order_list = body_data.order_list;
                console.log(JSON.stringify(this.order_list));
            });
        },
 
        async OnClick_EditProductCoin() {
            let pid = this.dialog_selected_item.PID;
            let process_state = this.dropdown_selected;
            let comment = this.dialog_cancel_commment;
            if(process_state == "CANCEL"){
                if(comment == ''){
                    alert("취소처리에는 사유 작성이 필요합니다.");
                    return;
                }
            }
            this.CPU_EDIT_COIN_ORDER_STATE({pid , process_state , comment}).then((body_data)=>{
                this.Load_OrderList();
            });
            this.OnClick_ClosePopup();
        },
        OnClick_ShowPopup_EditCoin(item)
        {
        //dialog_selected_item
            this.dialog_selected_item = item;
            this.dialog_popup = true;
        },    
        OnClick_ClosePopup()
        { 
            this.dialog_popup = false;
        },       
        formatCoin(value) {
            if (typeof value !== 'number') return value;
            return value.toLocaleString();
        },
        toggleDropdown() {
            this.dropdown_open = !this.dropdown_open
        },
        selectItem(item) {
            this.dropdown_selected = item
            this.dropdown_open = false
        },
        handleClickOutside(event) {
            if (!this.$el.contains(event.target)) {
                this.dropdown_open = false
            }
        },
        isAfterThisMonday(dateStr) {
            if (!dateStr) return false;
            const inputDate = new Date(dateStr.replace(/-/g, '/'));
            const now = new Date();
            // Get this week's Monday 00:00:00
            const day = now.getDay();
            const diff = now.getDate() - day + (day === 0 ? -6 : 1); // Monday as start of week
            const monday = new Date(now.setDate(diff));
            monday.setHours(0, 0, 0, 0);
            return inputDate >= monday;
        },
        isEnableCheckBox(pid)
        {
            let isEnableState = Object.prototype.hasOwnProperty.call(this.enable_check_list, pid);
            return isEnableState;            
        },
        checkBoxEnable_all()
        {
            this.order_list.forEach(element => {
                if(this.isEnableCheckBox(element.PID)){
                    this.$set(element, 'selected', true);
                }
            });
        },
        update_checked_Done() {
            const selected_pids = this.order_list
                .filter((item) => item.selected)
                .map((item) => item.PID);

            if (selected_pids.length === 0) {
                alert("선택된 항목이 없습니다.");
                return;
            }

            if (!confirm("선택된 항목을 완료처리 하시겠습니까?")) {
                return;
            }

            const failed = [];
            // reduce로 순차 실행 체인 구성
            selected_pids
                .reduce((p, pid) => {
                return p.then(() => {
                    return this.CPU_EDIT_COIN_ORDER_STATE({
                    pid: pid,
                    process_state: "DONE",
                    comment: ""
                    }).catch((e) => {
                    failed.push({ pid: pid, reason: e });
                    });
                });
                }, Promise.resolve())
                .then(() => {
                if (failed.length > 0) {
                    const msg = failed.map((f) => `PID ${f.pid}: ${String(f.reason)}`).join("\n");
                    alert(`일부 항목 처리 실패:\n${msg}`);
                }
                })
                .finally(() => {
                this.Load_OrderList();
                });
            }



        
    },
    computed: {
        
    },


    components:{
    },
    watch :{
    }
};
</script>

<style scoped>
.dialog_title_text {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 6px;
    margin-top: 6px;
}

.dialog_info_text {
    font-weight: bold;
    font-size: 16px;
    margin-top: 7px;
}

.dropdown {
  position: relative;
  width: 200px;
}

.dropdown-button {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  background-color: white;
  text-align: left;
  cursor: pointer;
}

.dropdown-menu {
    position: absolute;
  top: 100%;
  left: 0;
}

.dropdown-menu li {
  padding: 10px;
  cursor: pointer;
}

.dropdown-menu li:hover {
  background-color: #f0f0f0;
}

@media (max-width: 600px) {
  .v-data-table { overflow-x: auto; }
  .v-toolbar__content { flex-wrap: wrap; height: auto !important; padding: 8px; gap: 4px; }
}

</style>
